import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-footer',
  standalone: true,
  imports: [],
  templateUrl: './landing-footer.component.html',
  styles: ``
})
export class LandingFooterComponent {
  public date = new Date(Date.now()).getFullYear();
}
